<ng-component *ngComponentOutlet="anfrageLiveSharingComponent"></ng-component>
<div class="h-100 d-flex overflow-y-hidden overflow-x-hidden">
    <prozess-navigation id="resizableLeft" class="navigation" [ngClass]="{ 'collapsed': !showProzessNavigation }">
        <div>
            <app-navigation-item
                *ngFor="let navItem of navItemList"
                [name]="navItem.name"
                [href]="'./' + navItem.link"
                [isValid]="true"
                [isActive]="isCurrentRoute(navItem.abschnitt)"
                [showValidationStatus]="false"
                [formIcon]="navItem.icon"
                (click)="onAppNavigationItemClick()"
                [hasChildren]="shouldShowSubsectionsInNavigation(navItem.abschnitt) && navItem.childAbschnitte && navItem.childAbschnitte.length > 0"
                [hasNephews]="hasNephews(navItemList)"
                [isExpanded]="shouldShowSubsectionsInNavigation(navItem.abschnitt) && isParentOpen(navItem.abschnitt)"
                >
    
                <div group *ngIf="shouldShowSubsectionsInNavigation(navItem.abschnitt) && navItem.childAbschnitte && navItem.childAbschnitte.length > 0">
                    <app-navigation-item
                        *ngFor="let navItemChild of navItem.children"
                        [name]="navItemChild.name"
                        [href]="navItemChild.link"
                        [isValid]="true"
                        [showValidationStatus]="false"
                        [isSubItem]="true"
                        [isActive]="isCurrentRoute(navItem.abschnitt, navItemChild.abschnitt)"
                        [reportStatusIcon]="iconReportStatus(navItemChild.id)"
                        [reportStatusIconTitle]="iconReportStatusTitle(navItemChild.id) | translate"
                        [formIcon]="navItemChild.icon"
                        (click)="onAppNavigationItemClick()"
                        >
                    </app-navigation-item>
                </div>
            </app-navigation-item>
        </div>
        <div (mousedown)="draggableSidebar.onMouseDown($event, 'resizableLeft')" class="resize-bar right" [ngClass]="{'hidden' : ! showProzessNavigation}"></div>
    </prozess-navigation>

    <main class="content" id="main-content">
        <div id="topPosition"></div>
        <router-outlet></router-outlet>
    </main>

    <ng-component *ngComponentOutlet="detailSidepaneComponent"></ng-component>

</div>